import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { delay } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NAVIGATE_ROUTES } from '../../global/constants';
import { ApiService } from '../api-service/api.service';

@Injectable({
    providedIn: 'root',
})
export class ResetPassword {
    apiUrl: string = environment.url;
    responseData: any[] = [];
    verifyExpiry: any[] = [];
    userId: any;
    userPassword: any[] = [];
    error: any[] = [];
    apiEndPoint = NAVIGATE_ROUTES;
    constructor(private apiService: ApiService) {}
    async resetPwd(
        emailAddress: string,
        reset_token_expiry: number
    ): Promise<Observable<any>> {
        await this.apiService
            .put(this.apiEndPoint.FORGOT_PASSWORD, {
                email: emailAddress,
                reset_password_token_expiry: reset_token_expiry,
            })
            .then((resdata) => {
                this.responseData.length = 0;
                this.responseData.push(resdata);
            });
        return of(this.responseData);
    }
    async resetVerification(token: string): Promise<Observable<any>> {
        this.verifyExpiry = [];
        this.apiService
            .post(this.apiUrl + this.apiEndPoint.VERIFY_FORGOT_PASSWORD_TOKEN, {
                token: token,
            })
            .then((resdata) => {
                this.verifyExpiry.push(resdata);
            });
        return of(this.verifyExpiry).pipe(delay(100));
    }

    async resetVerificationTwo(token: string): Promise<Observable<any>> {
        const url = `${
            this.apiUrl + this.apiEndPoint.VERIFY_FORGOT_PASSWORD_TOKEN
        }`;
        const res: any = [];
        await this.apiService.post(url, { token }).then((_resdata: any) => {
            if (_resdata) {
                res.push(_resdata);
            }
        });
        return of(res);
    }

    async setNewPass(data: any): Promise<Observable<any>> {
        this.userPassword = [];
        await this.apiService
            .put(this.apiEndPoint.SET_NEW_PASSWORD, { data })
            .then((resdata: any) => {
                this.userPassword.push(resdata);
            });
        return of(this.userPassword);
    }
}
